import { Injectable } from '@angular/core';

@Injectable()
export class FlashService {

  constructor() { }

  show(text,className) {

  }
  
  hide() {

  }

}



// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/flash/flash.service.ts